import { Box } from './box'
import { Clock } from './clock'
import { Events } from './events'
import { News } from './news'
import { Weather } from './weather'
import { Holiday } from './holiday'
import { Transit } from './transit'

const Panels = {
  weather: Weather,
  sign: Clock,
  holiday: Holiday,
  news: News,
  clock: Clock,
  conditions: Clock,
  display: Clock,
  event: Events,
  transit: Transit
}

export const Panel = ({ panel }) => {
  // Empty/unknown slots still render a Box so the grid keeps its shape
  if (!panel) return <Box />
  const Comp = Panels[panel.type]
  if (!Comp) return <Box />

  return <Comp {...panel} />
}
